import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import BroadcastFullscreen from "@/pages/BroadcastFullscreen";
import RadarPage from "@/pages/RadarPage";
import ForecastArchive from "@/pages/ForecastArchive";
import Gameday from "@/pages/Gameday";
import StormModeBanner from "@/components/StormModeBanner";
import { Atmosphere } from "@/components/Atmosphere";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <StormModeBanner />
        <BrowserRouter>
          <Atmosphere />
          <div className="relative z-[1]">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/radar" element={<RadarPage />} />
            <Route path="/gameday" element={<Gameday />} />
            <Route path="/forecast" element={<ForecastArchive />} />
            <Route path="/forecast/:id" element={<ForecastArchive />} />
            <Route path="/broadcast" element={<BroadcastFullscreen />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
          </div>
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: "#121826",
              border: "1px solid rgba(255,255,255,0.1)",
              color: "white",
              fontFamily: "IBM Plex Sans, sans-serif",
            },
          }}
        />
      </AuthProvider>
    </div>
  );
}

export default App;
